import React from 'react';
import { useMutation } from 'react-apollo-hooks';
import PropTypes from 'prop-types';
import { loader } from 'graphql.macro';

import Select from '../Select';

import { ReactComponent as ListIcon } from 'icons/list.svg';

import s from './PageSize.module.css';

const SET_TABLE_VIEW_SETTINGS_MUTATION = loader('../../gql/mutations/SetTableViewSettings.gql');

const TABLE_SETTINGS_IN_CACHE = {
  CLIENTS: 'clientsTableSettings',
  CLIENT_ORDERS: 'clientOrdersTableSettings',
  FEEDBACKS: 'feedbacksTableSettings',
};

const PageSize = ({ table, selected, afterSet, onChange, ...props }) => {
  const [setTableViewSettingsMutation] = useMutation(SET_TABLE_VIEW_SETTINGS_MUTATION, {
    update: (cache, { data: { setTableViewSettings } }) => {
      afterSet(cache, { [TABLE_SETTINGS_IN_CACHE[table]]: setTableViewSettings });
    },
  });

  const setPageSize = pageSize => {
    setTableViewSettingsMutation({ variables: { table, tableViewSettings: { pageSize } } });
  };

  return (
    <Select
      label={
        <div className={s.label}>
          <div className={s.content}>
            <ListIcon />
            {selected}
          </div>
        </div>
      }
      items={[10, 50, 100].map(pageSize => ({
        label: pageSize,
        onClick: () => {
          setPageSize(pageSize);
          onChange(pageSize);
        },
      }))}
      {...props}
    />
  );
};

PageSize.propTypes = {
  table: PropTypes.oneOf(['CLIENTS', 'CLIENT_ORDERS', 'FEEDBACKS']).isRequired,
  selected: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  afterSet: PropTypes.func.isRequired,
};

export default PageSize;
